(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // Mobile nav
  var menuBtn = qs('[data-menu-open]');
  var menuClose = qs('[data-menu-close]');
  var mobileNav = qs('[data-mobile-nav]');
  var overlay = qs('[data-mobile-overlay]');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
  }

  if (menuBtn) menuBtn.addEventListener('click', openNav);
  if (menuClose) menuClose.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  function readVariants(form) {
    var data = qs('[data-variant-data]', form);
    if (!data) return [];
    try {
      return JSON.parse(data.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getOptionGroups(form) {
    return qsa('.product-form__option[data-option-position]', form);
  }

  function getSelections(form) {
    var selections = {};
    getOptionGroups(form).forEach(function (group) {
      var position = group.getAttribute('data-option-position');
      var select = qs('[data-option-select]', group);
      var selectedButton = qs('.product-option__value.is-selected', group);
      selections[position] = select ? select.value : (selectedButton ? selectedButton.getAttribute('data-option-value') : '');
    });
    return selections;
  }

  function matchesSelections(variant, selections, exceptPosition) {
    return Object.keys(selections).every(function (position) {
      return position === String(exceptPosition) || variant.options[Number(position)] === selections[position];
    });
  }

  function findVariant(variants, selections, changedPosition, changedValue) {
    var exact = variants.filter(function (variant) {
      return matchesSelections(variant, selections) && variant.options.length === Object.keys(selections).length;
    });
    if (exact.length) return exact[0];

    // If a newly selected combination is unavailable, keep the clicked value and
    // choose the first available compatible variant so every control stays usable.
    var compatible = variants.filter(function (variant) {
      return variant.available && variant.options[Number(changedPosition)] === changedValue && matchesSelections(variant, selections, changedPosition);
    });
    if (compatible.length) return compatible[0];

    return variants.filter(function (variant) {
      return variant.available && variant.options[Number(changedPosition)] === changedValue;
    })[0] || variants.filter(function (variant) {
      return matchesSelections(variant, selections);
    })[0] || variants[0];
  }

  function isValueAvailable(variants, selections, position, value) {
    return variants.some(function (variant) {
      return variant.available && variant.options[Number(position)] === value && matchesSelections(variant, selections, position);
    });
  }

  function updateAvailability(form, variants) {
    var selections = getSelections(form);
    getOptionGroups(form).forEach(function (group) {
      var position = group.getAttribute('data-option-position');
      qsa('[data-option-value]', group).forEach(function (button) {
        var value = button.getAttribute('data-option-value');
        var available = isValueAvailable(variants, selections, position, value);
        // Keep the active value clickable even if the current variant is sold out.
        if (value === selections[position]) available = true;
        button.disabled = !available;
      });
      var select = qs('[data-option-select]', group);
      if (select) {
        qsa('option', select).forEach(function (option) {
          option.disabled = !isValueAvailable(variants, selections, position, option.value) && option.value !== selections[position];
        });
      }
    });
  }

  function syncForm(form, variant, variants) {
    if (!variant) return;
    var idInput = qs('[data-variant-id]', form);
    var price = qs('[data-product-price]', form.parentNode) || qs('[data-product-price]');
    var currentPrice = qs('[data-price-current]', price);
    var comparePrice = qs('[data-price-compare]', price);
    var addButton = qs('[data-add-to-cart]', form);
    var addText = qs('[data-add-to-cart-text]', form);

    if (idInput) idInput.value = variant.id;
    getOptionGroups(form).forEach(function (group) {
      var position = Number(group.getAttribute('data-option-position'));
      var value = variant.options[position];
      qsa('[data-option-value]', group).forEach(function (button) {
        var selected = button.getAttribute('data-option-value') === value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var select = qs('[data-option-select]', group);
      if (select) select.value = value;
    });
    if (currentPrice) currentPrice.textContent = variant.price;
    if (comparePrice) {
      comparePrice.textContent = variant.compare_at_price || '';
      comparePrice.hidden = !variant.compare_at_price;
    }
    if (addButton) addButton.disabled = !variant.available;
    if (addText) addText.textContent = variant.available ? addButton.getAttribute('data-add-label') : addButton.getAttribute('data-sold-out-label');
    updateAvailability(form, variants);
  }

  // Product form: size is a pill selector; other options remain native selects.
  qsa('[data-product-form]').forEach(function (form) {
    var variants = readVariants(form);
    if (!variants.length) return;

    getOptionGroups(form).forEach(function (group) {
      var position = group.getAttribute('data-option-position');
      qsa('[data-option-value]', group).forEach(function (button) {
        button.addEventListener('click', function () {
          qsa('[data-option-value]', group).forEach(function (sibling) {
            var selected = sibling === button;
            sibling.classList.toggle('is-selected', selected);
            sibling.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          var selections = getSelections(form);
          var variant = findVariant(variants, selections, position, button.getAttribute('data-option-value'));
          syncForm(form, variant, variants);
        });
      });

      var select = qs('[data-option-select]', group);
      if (select) {
        select.addEventListener('change', function () {
          var selections = getSelections(form);
          var variant = findVariant(variants, selections, position, select.value);
          syncForm(form, variant, variants);
        });
      }
    });

    var initialSelections = getSelections(form);
    var initialVariant = findVariant(variants, initialSelections, 0, initialSelections[0]);
    syncForm(form, initialVariant, variants);
  });
})();


/* Rolling 48h flash countdown: end = floor(now/PERIOD)*PERIOD + PERIOD; never permanently ends; does not change Shopify price. */
(function () {
  var PERIOD_MS = 48 * 60 * 60 * 1000;
  function pad(n) { return String(n).padStart(2, '0'); }
  function nextEnd(now) {
    return Math.floor(now / PERIOD_MS) * PERIOD_MS + PERIOD_MS;
  }
  function format(ms) {
    if (ms < 0) ms = 0;
    var total = Math.floor(ms / 1000);
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function tick() {
    var nodes = document.querySelectorAll('[data-flash-countdown]');
    if (!nodes.length) return;
    var now = Date.now();
    var end = nextEnd(now);
    var label = format(end - now);
    nodes.forEach(function (el) { el.textContent = label; });
  }
  tick();
  setInterval(tick, 1000);
})();
